import { VIDEO_ACTION_TYPES } from './types';

// Initial video state
export const initialVideoState = {
  mainStream: null, // Primary video stream (admin stream in normal mode, user stream in mutual mode)
  adminStream: null, // Admin's video stream
  userStream: null, // User's video stream
  feedbackStream: null, // User's camera stream for form feedback
  userCameraEnabled: false,
  videoReady: false,
  loading: true,
  cameraError: null, // Camera error state: { type, message, recoveryActions }
  cameraConflict: null, // Camera conflict state: { activeFeature, requestingFeature, options }
};

// Video state reducer
export const videoReducer = (state = initialVideoState, action) => {
  switch (action.type) {
    case VIDEO_ACTION_TYPES.SET_MAIN_STREAM:
      console.log('🔄 REDUCER: SET_MAIN_STREAM - setting loading to FALSE');
      return {
        ...state,
        mainStream: action.payload,
        loading: false,
      };
    case VIDEO_ACTION_TYPES.SET_ADMIN_STREAM:
      return {
        ...state,
        adminStream: action.payload,
      };
    case VIDEO_ACTION_TYPES.SET_USER_STREAM:
      return {
        ...state,
        userStream: action.payload,
        userCameraEnabled: !!action.payload,
      };
    case VIDEO_ACTION_TYPES.SET_FEEDBACK_STREAM:
      return {
        ...state,
        feedbackStream: action.payload,
        videoReady: !!action.payload,
      };
    case VIDEO_ACTION_TYPES.CLEAR_MAIN_STREAM:
      return {
        ...state,
        mainStream: null,
        loading: false,
      };
    case VIDEO_ACTION_TYPES.CLEAR_ALL_STREAMS:
      return {
        ...state,
        mainStream: null,
        adminStream: null,
        userStream: null,
        feedbackStream: null,
        userCameraEnabled: false,
        videoReady: false,
        loading: false,
      };
    case VIDEO_ACTION_TYPES.SET_LOADING:
      console.log(
        '🔄 REDUCER: SET_LOADING - setting loading to',
        action.payload
      );
      return {
        ...state,
        loading: action.payload,
      };
    case VIDEO_ACTION_TYPES.SET_USER_CAMERA_ENABLED:
      return {
        ...state,
        userCameraEnabled: action.payload,
      };
    case VIDEO_ACTION_TYPES.SET_VIDEO_READY:
      return {
        ...state,
        videoReady: action.payload,
      };
    case VIDEO_ACTION_TYPES.SET_CAMERA_ERROR:
      return {
        ...state,
        cameraError: action.payload,
        loading: false,
      };
    case VIDEO_ACTION_TYPES.CLEAR_CAMERA_ERROR:
      return {
        ...state,
        cameraError: null,
      };
    case VIDEO_ACTION_TYPES.SET_CAMERA_CONFLICT:
      return {
        ...state,
        cameraConflict: action.payload,
      };
    case VIDEO_ACTION_TYPES.CLEAR_CAMERA_CONFLICT:
      return {
        ...state,
        cameraConflict: null,
      };
    default:
      return state;
  }
};
